class SendMessageError extends Error {
    name = 'SendMessageError';
    constructor(message) {
        super(message || 'Can\'t send message. Params are invalid');
    }
}
class SendReplyError extends Error {
    name = 'SendReplyError';
    constructor(message) {
        super(message || 'Can\'t send reply. Params are invalid');
    }
}

export { SendMessageError, SendReplyError };
